export default {
  menu: {
    close: "Close",
    install: "Install App",
    referenceData: "Reference Data",
    administration: "Administration",
    management: "Management",
  },
  sidebar: {
    toggle: "Toggle sidebar",
    closeMobile: "Close menu",
  },
  header: {
    menu: "Menu",
    home: "Home",
    login: "Login",
  },
  userPanel: {
    roles: "Role(s)",
    signout: "Sign out",
    profile: "Profile",
  },
  navigation: {
    moduleAdministration: {
      title: "Module Administration",
      caption: "Module Administration",
    },
    admin: {
      title: "Administration",
      caption: "Tenant & User Management",
      users: {
        title: "Users",
        caption: "Manage users",
      },
      customize: {
        title: "Customize your space",
        caption: "Theme etc.",
      },
      tenantConfig: {
        title: "Tenant Configuration",
        caption: "Key-value pairs of your tenant",
      },
      clientApps: {
        title: "Client Applications",
        caption: "Manage application tokens",
      },
    },
    superAdmin: {
      title: "Global Administration",
      caption: "Tenants & Configuration",
      globalConfig: {
        title: "Global Configuration",
        caption: "Manage global settings",
      },
      tenants: {
        title: "Tenants",
        caption: "Manage tenants",
      },
    },
    account: {
      title: "Me",
      caption: "Profile",
    },
    security: {
      title: "Security",
      caption: "Multi-factor authentication",
    },
    seed: {
      title: "Initialize Data",
      caption: "Initialize reference and sample data",
      reference: {
        title: "Reference Data",
        caption:
          "Initialize business sectors, skills, and other reference data",
        action: "Seed Reference Data",
        success: "Reference data initialized successfully",
        error: "Failed to initialize reference data",
      },
      sample: {
        title: "Sample Data",
        caption: "Initialize sample companies and related data",
        action: "Seed Sample Data",
        success: "Sample data initialized successfully",
        error: "Failed to initialize sample data",
      },
    },
  },
  backoffice: "Global Administration",
  version: "Version",
};
